import { css } from 'linaria';

export const loadMoreContainer = css`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: var(--space-400) 0 var(--space-500) 0;
`;

export const loadMoreContainer__button = css`
  min-width: 240px;

  div {
    color: var(--brand-primary)
  }
`;